import { isEdge, isIE } from '@/ts/helpers/IE.ts'

export const publicPath: string | undefined = import.meta.env.BASE_URL

export const preferredLanguage: string =
  window.navigator['userLanguage'] || window.navigator.language

export const geolocationAvailable = !isEdge() && !isIE() && ('geolocation' in navigator)
